import { GET_PAY_LINK } from "../../routes";
import customAxios from "../../customAxios";
import { IGetPayLink } from "../../../types/common.interface";

async function getPayLink(props: IGetPayLink) {
  var thisUrl = GET_PAY_LINK;

  let body: any = {
    serviceId: props?.serviceId,
    getway: props?.gateway,
    target: "REDIRECT_TO_PAY_SUBSCRIPTION_DASHBOARD",
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default getPayLink;
